<!--
 * @Description:
 * @Autor: Zhongyu
 * @Date: 2022-02-07 13:37:04
 * @LastEditors: Zhongyu
 * @LastEditTime: 2022-02-22 11:00:43
-->
<template>
  <div class="route-summary">
    <div id="route-summary-map" class="route-summary-map"></div>
    <div class="route-summary-body">
      <div class="left">
        <box :width="240" :height="777">
          <div class="title">
            路线列表
          </div>
          <ul>
            <li
              v-for="item in menus"
              :key="item.id"
              :class="{ select: select == item.id }"
              @click="heandleClickMenu(item)"
            >
              <span class="icon"></span>
              <span>{{ item.title }}</span>
            </li>
          </ul>
        </box>
      </div>
      <div class="right">
        <box :width="1610" :height="777">
          <router-view> </router-view>
        </box>
      </div>
    </div>
  </div>
</template>

<script>
import Box from "@/components/Box";
import AMap from "AMap";
export default {
  components: {
    Box
  },
  data() {
    return {
      map: null,
      select: 1,
      menus: [
        {
          id: 1,
          title: "班车路线",
          url: "/route-summary/bag-car"
        },
        {
          id: 2,
          title: "包车路线",
          url: "/route-summary/team-car"
        },
        {
          id: 3,
          title: "客运路线",
          url: "/route-summary/passenger"
        }
      ]
    };
  },
  watch: {
    "$route.path": {
      handler(val) {
        this.dealWithMenu(val);
      },
      deep: true
    }
  },
  mounted() {
    this.initMap();
    this.dealWithMenu(this.$route.path);
    this.$store.dispatch("setButtonStatus", 2);
  },
  methods: {
    dealWithMenu(val) {
      let menus = this.menus;
      let menu = menus.find(item => {
        return val == item.url;
      });
      if (menu) {
        this.select = menu.id;
      }
    },
    initMap() {
      let map = new AMap.Map("route-summary-map", {
        resizeEnable: true, //自适应大小
        zoom: 13, //初始视窗
        scrollWheel: false,
        viewMode: "3D",
        mapStyle: "amap://styles/48973c04a03806fd9a451891d922af47" //设置地图的显示样式
      });
      // console.log(map);
      // //  显示缩放加减号
      // // eslint-disable-next-line no-undef
      // AMap.plugin(["AMap.ControlBar"], function() {
      //   // 添加 3D 罗盘控制
      //   // eslint-disable-next-line no-undef
      //   map.addControl(new AMap.ControlBar());
      // });
      this.map = map;
    },
    heandleClickMenu(item) {
      this.select = item.id;
      if (this.$route.path != item.url) {
        this.$router.push(item.url);
      }
    }
  }
};
</script>

<style lang="less">
@import "./index.less";
</style>
